import omit from 'lodash.omit';
import isEqual from 'lodash.isequal';
import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

import { UPDATE_CRITERIA } from 'store/search/search';

export const GET_LMIS_BEGIN = 'GET_LMIS_BEGIN';
export const GET_LMIS_SUCCESS = 'GET_LMIS_SUCCESS';
export const GET_LMIS_ERROR = 'GET_LMIS_ERROR';

const omittedlmisSearchParams = ['page', 'advertiserid', 'advertisergroup', 'sortmode', 'daterange'];

const initialState = {
  shouldUpdate: true,
  isDynamic: false,
  content: '',
  query: {}
};

const updateLmis = ({ shouldUpdate: updateStatus, isDynamic, query: lastQuery }, query) => {
  const newSearchParams = omit(query, omittedlmisSearchParams);
  const shouldUpdate = updateStatus || !isEqual(newSearchParams, lastQuery) || !isDynamic;

  return {
    query: newSearchParams,
    shouldUpdate
  };
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_CRITERIA: {
      const { query } = action.payload;

      return {
        ...state,
        ...updateLmis(state, query)
      };
    }

    case GET_LMIS_BEGIN: {
      return {
        ...state,
        isDynamic: false
      };
    }

    case GET_LMIS_SUCCESS: {
      const { content } = action.payload;

      return {
        ...state,
        content,
        isDynamic: true,
        shouldUpdate: false
      };
    }

    case GET_LMIS_ERROR: {
      return {
        ...state,
        isDynamic: false,
        content: ''
      };
    }

    default:
      return state;
  }
}

export const getSerpLmis = () => (dispatch, getState) => {
  const { lmis, location, user } = getState();
  const { query, shouldUpdate } = lmis;

  if (shouldUpdate) {
    const lmisParams = {
      placement: '90ae91',
      location: location.locale,
      loggedin: user.authenticated,
      ...query
    };

    dispatch({ type: GET_LMIS_BEGIN });

    return api.lmis.getLmis(lmisParams)
      .then(response => {
        return dispatch({
          type: GET_LMIS_SUCCESS,
          payload: response
        });
      })
      .catch(err => {
        return dispatch({
          type: GET_LMIS_ERROR,
          payload: err
        });
      });
  }
  return null;
};



/** WEBPACK FOOTER **
 ** ./app/store/lmis/lmis.js
 **/